import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getOurClientsDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  ourClientsMainContent: [
    {
      fieldName: "Our Client Title (EN)",
      fieldValue: "field_our_client_text",
      className: "col-span-6",
      type: "text",
      name: "field_our_client_text",
      formType: "input",
      label: "Our Client Title (EN)",
      placeholder: "Enter Our Client Title (EN)",
      validation: { required: "Our Client Title (EN) is required" },
    },
    {
      fieldName: "Our Client Title (MS)",
      fieldValue: "field_our_client_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_our_client_text_ms",
      formType: "input",
      label: "Our Client Title (MS)",
      placeholder: "Enter Our Client Title (MS)",
    },
    {
      fieldName: "Our Client Title (ZH)",
      fieldValue: "field_our_client_text_zhans",
      className: "col-span-6",
      type: "text",
      name: "field_our_client_text_zhans",
      formType: "input",
      label: "Our Client Title (ZH)",
      placeholder: "Enter Our Client Title (ZH)",
    },
    {
      fieldName: "Local Title (EN)",
      fieldValue: "field_local_en",
      className: "col-span-6",
      type: "text",
      name: "field_local_en",
      formType: "input",
      label: "Local Title (EN)",
      placeholder: "Enter Local Title (EN)",
    },
    {
      fieldName: "Local Title (MS)",
      fieldValue: "field_local_ms",
      className: "col-span-6",
      type: "text",
      name: "field_local_ms",
      formType: "input",
      label: "Local Title (MS)",
      placeholder: "Enter Local Title (MS)",
    },
    {
      fieldName: "Local Title (ZH)",
      fieldValue: "field_local_zh",
      className: "col-span-6",
      type: "text",
      name: "field_local_zh",
      formType: "input",
      label: "Local Title (ZH)",
      placeholder: "Enter Local Title (ZH)",
    },
    {
      fieldName: "International Title (EN)",
      fieldValue: "field_international_en",
      className: "col-span-6",
      type: "text",
      name: "field_international_en",
      formType: "input",
      label: "International Title (EN)",
      placeholder: "Enter International Title (EN)",
    },
    {
      fieldName: "International Title (MS)",
      fieldValue: "field_international_ms",
      className: "col-span-6",
      type: "text",
      name: "field_international_ms",
      formType: "input",
      label: "International Title (MS)",
      placeholder: "Enter International Title (MS)",
    },
    {
      fieldName: "International Title (ZH)",
      fieldValue: "field_international_zh",
      className: "col-span-6",
      type: "text",
      name: "field_international_zh",
      formType: "input",
      label: "International Title (ZH)",
      placeholder: "Enter International Title (ZH)",
    },
    // {
    //   fieldName: "Publish",
    //   fieldValue: "published",
    //   className: "col-span-6",
    //   type: "checkbox",
    //   name: "published",
    //   label: "Publish",
    //   formType: "checkbox",
    //   placeholder: "Check to publish",
    // },
  ],
  localClients: [
    {
      fieldName: "Order Sequence",
      fieldValue: "field_local_order_sequence",
      className: "col-span-6",
      type: "text",
      name: "field_local_order_sequence",
      formType: "number",
      label: "Order Sequence",
      placeholder: "Enter Order Sequence",
      validation: { required: "Order Sequence is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_local_client_ms",
      className: "col-span-6",
      type: "text",
      name: "field_local_client_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_local_client_zh",
      className: "col-span-6",
      type: "text",
      name: "field_local_client_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
    },

    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      label: "Published",
      formType: "checkbox",
      placeholder: "Check to publish",
    },
  ],

  internationalClients: [
    {
      fieldName: "Order Sequence",
      fieldValue: "field_international_order_sequen",
      className: "col-span-6",
      type: "text",
      name: "field_international_order_sequen",
      formType: "number",
      label: "Order Sequence",
      placeholder: "Enter Order Sequence",
      validation: { required: "Order Sequence is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_international_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_international_title_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_international_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_international_title_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
    },

    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      label: "Published",
      formType: "checkbox",
      placeholder: "Check to publish",
    },
  ],
};
